export const frontmatter = {
  title: "Contracts",
  order: 4,
}

## Deployed Contract Addresses

Below is a list of our deployed contract addresses for Scale.Farm on Base.

| Contract Name             | Contract Address                                                                                                      |
| ------------------------- | --------------------------------------------------------------------------------------------------------------------- |
| SCALE                     | [0x54016a4848a38f257b6e96331f7404073fd9c32c](https://basescan.org/address/0x54016a4848a38f257b6e96331f7404073fd9c32c) |
| PairFactory               | [0xed8db60acc29e14bc867a497d94ca6e3ceb5ec04](https://basescan.org/address/0xed8db60acc29e14bc867a497d94ca6e3ceb5ec04) |
| ⚠ Router v1 (deprecated) | [0x5e9d25014d01323d6f8c0c6640572e4444d11c94](https://basescan.org/address/0x5e9d25014d01323d6f8c0c6640572e4444d11c94) |
| Router v2                 | [0x2F87Bf58D5A9b2eFadE55Cdbd46153a0902be6FA](https://basescan.org/address/0x2F87Bf58D5A9b2eFadE55Cdbd46153a0902be6FA) |
| VotingEscrow              | [0x28c9c71c776a1203000b56c0cca48bef1cd51c53](https://basescan.org/address/0x28c9c71c776a1203000b56c0cca48bef1cd51c53) |
| GaugeFactory              | [0xb136b45e3e241bb0d0c037395446cf42e4db13d6](https://basescan.org/address/0xb136b45e3e241bb0d0c037395446cf42e4db13d6) |
| BribeFactory              | [0xcb418f555974ef099a528c2c866b35520230ae18](https://basescan.org/address/0xcb418f555974ef099a528c2c866b35520230ae18) |
| Voter                     | [0x46abb88ae1f2a35ea559925d99fdc5441b592687](https://basescan.org/address/0x46abb88ae1f2a35ea559925d99fdc5441b592687) |
| Minter                    | [0x44621CcEF14730A2F864eC11311A7F0BCB005685](https://basescan.org/address/0x44621CcEF14730A2F864eC11311A7F0BCB005685) |

### Only trust the addresses labelled in our docs!
